export default {"src":"/_next/static/media/hero-brands.69df86ee.svg","height":54,"width":480,"blurWidth":0,"blurHeight":0};